import { CountryEnums } from "models/enums";
import { SelectInputItemProps } from "models/propTypes/wintFormPropsTypes";
import { EnumHelper, LocalizationHelperInstance } from "utils/helpers";

const CountryHelper = {
  getCountryCodeList: () => {
    return EnumHelper.getItemKeys(CountryEnums.CountryCode);
  },
  getCountryAutoCompleteList: () => {
    return CountryHelper.getCountryCodeList().map((key, index) => ({
      id: key,
      value: LocalizationHelperInstance.getFormattedMessage(key),
    }));
  },
  getCountrySelectionList: (): SelectInputItemProps[] => {
    return CountryHelper.getCountryCodeList().map((key, index) => ({
      value: key,
      label: LocalizationHelperInstance.getFormattedMessage(key),
    }));
  },
};
export default CountryHelper;
